import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "chat-line chat-line-reply-list"
};
const _hoisted_2 = {
  class: "chat-line-inner"
};
const _hoisted_3 = {
  class: "chat-icon"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "chat-item"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  key: 0,
  class: "bar"
};
const _hoisted_8 = {
  class: "bar-item"
};
const _hoisted_9 = {
  class: "bar-item"
};
const _hoisted_10 = {
  class: "bar-item"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 1,
  class: "chat-line chat-line-reply-chat"
};
const _hoisted_13 = {
  class: "chat-line-inner"
};
const _hoisted_14 = {
  class: "chat-icon"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "chat-item"
};
const _hoisted_17 = {
  class: "content-wrapper"
};
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = {
  key: 0,
  class: "bar"
};
const _hoisted_20 = {
  class: "bar-item"
};
const _hoisted_21 = {
  class: "bar-item bg"
};
const _hoisted_22 = {
  key: 0
};
import { Clock, DocumentCopy, Refresh } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { dateFormat, processContent } from "@/utils/libs";
import hl from "highlight.js";
import emoji from "markdown-it-emoji";
import mathjaxPlugin from "markdown-it-mathjax3";
import MarkdownIt from "markdown-it";

// eslint-disable-next-line no-undef,no-unused-vars

export default {
  __name: 'ChatReply',
  props: {
    data: {
      type: Object,
      default: {
        icon: "",
        content: "",
        created_at: "",
        tokens: 0
      }
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    listStyle: {
      type: String,
      default: "list"
    }
  },
  emits: ["regen"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const md = new MarkdownIt({
      breaks: true,
      html: true,
      linkify: true,
      typographer: true,
      highlight: function (str, lang) {
        const codeIndex = parseInt(Date.now()) + Math.floor(Math.random() * 10000000);
        // 显示复制代码按钮
        const copyBtn = `<span class="copy-code-btn" data-clipboard-action="copy" data-clipboard-target="#copy-target-${codeIndex}">复制</span>
<textarea style="position: absolute;top: -9999px;left: -9999px;z-index: -9999;" id="copy-target-${codeIndex}">${str.replace(/<\/textarea>/g, "&lt;/textarea>")}</textarea>`;
        if (lang && hl.getLanguage(lang)) {
          const langHtml = `<span class="lang-name">${lang}</span>`;
          // 处理代码高亮
          const preCode = hl.highlight(str, {
            language: lang
          }).value;
          // 将代码包裹在 pre 中
          return `<pre class="code-container"><code class="language-${lang} hljs">${preCode}</code>${copyBtn} ${langHtml}</pre>`;
        }

        // 处理代码高亮
        const preCode = md.utils.escapeHtml(str);
        // 将代码包裹在 pre 中
        return `<pre class="code-container"><code class="language-${lang} hljs">${preCode}</code>${copyBtn}</pre>`;
      }
    });
    md.use(mathjaxPlugin);
    md.use(emoji);
    const emits = __emit;
    if (!props.data.icon) {
      props.data.icon = "images/gpt-icon.png";
    }
    const synthesis = text => {
      console.log(text);
      ElMessage.info("语音合成功能暂不可用");
    };

    // 重新生成
    const reGenerate = prompt => {
      console.log(prompt);
      emits("regen", prompt);
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return __props.listStyle === 'list' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: __props.data.icon,
        alt: "ChatGPT"
      }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: "content",
        innerHTML: _unref(md).render(_unref(processContent)(__props.data.content))
      }, null, 8, _hoisted_6), __props.data.created_at ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Clock))]),
        _: 1
      }), _createTextVNode(" " + _toDisplayString(_unref(dateFormat)(__props.data.created_at)), 1)]), _createElementVNode("span", _hoisted_9, "tokens: " + _toDisplayString(__props.data.tokens), 1), _createElementVNode("span", _hoisted_10, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: "复制回答",
        placement: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "copy-reply",
          "data-clipboard-text": __props.data.content
        }, {
          default: _withCtx(() => [_createVNode(_unref(DocumentCopy))]),
          _: 1
        }, 8, ["data-clipboard-text"])]),
        _: 1
      })]), !__props.readOnly ? (_openBlock(), _createElementBlock("span", _hoisted_11, [_createElementVNode("span", {
        class: "bar-item",
        onClick: _cache[0] || (_cache[0] = $event => reGenerate(__props.data.prompt))
      }, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: "重新生成",
        placement: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Refresh))]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("span", {
        class: "bar-item",
        onClick: _cache[1] || (_cache[1] = $event => synthesis(__props.data.content))
      }, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: "生成语音朗读",
        placement: "bottom"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("i", {
          class: "iconfont icon-speaker"
        }, null, -1)])),
        _: 1
      })])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
        src: __props.data.icon,
        alt: "ChatGPT"
      }, null, 8, _hoisted_15)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
        class: "content",
        innerHTML: _unref(md).render(_unref(processContent)(__props.data.content))
      }, null, 8, _hoisted_18)]), __props.data.created_at ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(Clock))]),
        _: 1
      }), _createTextVNode(" " + _toDisplayString(_unref(dateFormat)(__props.data.created_at)), 1)]), _createElementVNode("span", _hoisted_21, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: "复制回答",
        placement: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "copy-reply",
          "data-clipboard-text": __props.data.content
        }, {
          default: _withCtx(() => [_createVNode(_unref(DocumentCopy))]),
          _: 1
        }, 8, ["data-clipboard-text"])]),
        _: 1
      })]), !__props.readOnly ? (_openBlock(), _createElementBlock("span", _hoisted_22, [_createElementVNode("span", {
        class: "bar-item bg",
        onClick: _cache[2] || (_cache[2] = $event => reGenerate(__props.data.prompt))
      }, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: "重新生成",
        placement: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Refresh))]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("span", {
        class: "bar-item bg",
        onClick: _cache[3] || (_cache[3] = $event => synthesis(__props.data.content))
      }, [_createVNode(_component_el_tooltip, {
        class: "box-item",
        effect: "dark",
        content: "生成语音朗读",
        placement: "bottom"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createElementVNode("i", {
          class: "iconfont icon-speaker"
        }, null, -1)])),
        _: 1
      })])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])]));
    };
  }
};